var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "decor-editor" },
    [
      _c(
        "div",
        { staticClass: "editor-topbar" },
        [
          _c(
            "a-button",
            { attrs: { icon: "arrow-left" }, on: { click: _vm.back } },
            [_vm._v("返回")]
          ),
          _c(
            "a-tag",
            {
              staticStyle: { "margin-left": "12px" },
              attrs: {
                color: _vm.typeMeta[_vm.page.pageType]
                  ? _vm.typeMeta[_vm.page.pageType].color
                  : "",
              },
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.typeMeta[_vm.page.pageType]
                      ? _vm.typeMeta[_vm.page.pageType].label
                      : _vm.page.pageType
                  ) +
                  "\n    "
              ),
            ]
          ),
          _c("a-input", {
            staticStyle: { width: "260px", "margin-left": "8px" },
            attrs: { placeholder: "页面名称" },
            model: {
              value: _vm.name,
              callback: function ($$v) {
                _vm.name = $$v
              },
              expression: "name",
            },
          }),
          _c("span", { staticClass: "draft-tip" }, [
            _vm._v("拖拽左侧组件到手机预览区排版；保存并发布后对顾客端生效"),
          ]),
          _c(
            "a-button",
            {
              staticStyle: { "margin-left": "auto" },
              attrs: { icon: "save", loading: _vm.saving },
              on: { click: _vm.save },
            },
            [_vm._v("保存")]
          ),
          _c(
            "a-button",
            {
              staticStyle: { "margin-left": "8px" },
              attrs: {
                type: "primary",
                icon: "cloud-upload",
                loading: _vm.saving,
              },
              on: { click: _vm.saveAndPublish },
            },
            [_vm._v("保存并发布")]
          ),
        ],
        1
      ),
      _c("div", { staticClass: "editor-body" }, [
        _c(
          "div",
          { staticClass: "editor-left" },
          [
            _c("div", { staticClass: "panel-title" }, [_vm._v("组件库")]),
            _vm._l(_vm.libGroups, function (group) {
              return _c(
                "div",
                { key: group.name, staticClass: "lib-group" },
                [
                  _c("div", { staticClass: "lib-group-title" }, [
                    _vm._v(_vm._s(group.name)),
                  ]),
                  _c(
                    "draggable",
                    {
                      attrs: {
                        list: group.types,
                        options: {
                          group: { name: "decor", pull: "clone", put: false },
                          sort: false,
                        },
                        clone: _vm.cloneMaterial,
                      },
                    },
                    _vm._l(group.types, function (t) {
                      return _c(
                        "div",
                        {
                          key: t.type,
                          staticClass: "lib-item",
                          on: {
                            click: function ($event) {
                              return _vm.addComponent(t.type)
                            },
                          },
                        },
                        [
                          _c("a-icon", { attrs: { type: t.icon } }),
                          _c("span", [_vm._v(_vm._s(t.label))]),
                        ],
                        1
                      )
                    }),
                    0
                  ),
                ],
                1
              )
            }),
          ],
          2
        ),
        _c("div", { staticClass: "editor-center" }, [
          _c(
            "div",
            { staticClass: "phone" },
            [
              _vm.components.length === 0
                ? _c("div", { staticClass: "phone-empty" }, [
                    _vm._v("从左侧拖入组件，或点击组件添加"),
                  ])
                : _vm._e(),
              _c(
                "draggable",
                {
                  staticClass: "phone-canvas",
                  attrs: { options: { group: "decor", animation: 150 } },
                  on: { add: _vm.onCanvasAdd },
                  model: {
                    value: _vm.components,
                    callback: function ($$v) {
                      _vm.components = $$v
                    },
                    expression: "components",
                  },
                },
                _vm._l(_vm.components, function (comp, index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      staticClass: "comp-item",
                      class: { "comp-selected": _vm.selectedIndex === index },
                      on: {
                        click: function ($event) {
                          return _vm.selectComponent(index)
                        },
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "comp-ops" },
                        [
                          _c("a-button", {
                            attrs: {
                              size: "small",
                              icon: "delete",
                              title: "删除",
                            },
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.removeComponent(index)
                              },
                            },
                          }),
                        ],
                        1
                      ),
                      comp.type === "banner"
                        ? _c("div", { staticClass: "p-banner" }, [
                            comp.data.images && comp.data.images.length
                              ? _c(
                                  "div",
                                  { staticClass: "p-banner-strip" },
                                  _vm._l(comp.data.images, function (img, idx) {
                                    return _c(
                                      "div",
                                      {
                                        key: idx,
                                        staticClass: "p-banner-cell",
                                      },
                                      [
                                        _vm.resolveImg(img.url)
                                          ? _c("img", {
                                              attrs: {
                                                src: _vm.resolveImg(img.url),
                                              },
                                            })
                                          : _c(
                                              "div",
                                              { staticClass: "p-placeholder" },
                                              [_vm._v("图片" + _vm._s(idx + 1))]
                                            ),
                                        _c("span", { staticClass: "p-badge" }, [
                                          _vm._v(_vm._s(idx + 1)),
                                        ]),
                                      ]
                                    )
                                  }),
                                  0
                                )
                              : _c("div", { staticClass: "p-placeholder" }, [
                                  _vm._v("轮播图"),
                                ]),
                          ])
                        : comp.type === "search"
                        ? _c("div", { staticClass: "p-search" }, [
                            _c("span", { staticClass: "p-search-icon" }, [
                              _vm._v("🔍"),
                            ]),
                            _c("span", { staticClass: "p-search-text" }, [
                              _vm._v(
                                _vm._s(comp.data.placeholder || "搜索菜品")
                              ),
                            ]),
                          ])
                        : comp.type === "notice"
                        ? _c("div", { staticClass: "p-notice" }, [
                            _vm._v(
                              "\n              📢 " +
                                _vm._s(comp.data.text || "公告内容") +
                                "\n              "
                            ),
                            comp.data.scrollable
                              ? _c("span", { staticClass: "p-notice-scroll" }, [
                                  _vm._v("滚动"),
                                ])
                              : _vm._e(),
                          ])
                        : comp.type === "grid-nav"
                        ? _c(
                            "div",
                            { staticClass: "p-grid" },
                            [
                              comp.data.items && comp.data.items.length
                                ? _vm._l(comp.data.items, function (item, idx) {
                                    return _c(
                                      "div",
                                      { key: idx, staticClass: "p-grid-item" },
                                      [
                                        item.icon && _vm.resolveImg(item.icon)
                                          ? _c("img", {
                                              staticClass: "p-grid-img",
                                              attrs: {
                                                src: _vm.resolveImg(item.icon),
                                              },
                                            })
                                          : _c(
                                              "div",
                                              { staticClass: "p-grid-icon" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    (item.title || "导").charAt(
                                                      0
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                        _c(
                                          "div",
                                          { staticClass: "p-grid-title" },
                                          [_vm._v(_vm._s(item.title || "导航"))]
                                        ),
                                      ]
                                    )
                                  })
                                : _c("div", { staticClass: "p-placeholder" }, [
                                    _vm._v("金刚区"),
                                  ]),
                            ],
                            2
                          )
                        : comp.type === "title-bar"
                        ? _c("div", { staticClass: "p-title-bar" }, [
                            _c("span", { staticClass: "p-tb-title" }, [
                              _vm._v(_vm._s(comp.data.title || "标题")),
                            ]),
                            comp.data.moreText
                              ? _c("span", { staticClass: "p-tb-more" }, [
                                  _vm._v(_vm._s(comp.data.moreText) + " ›"),
                                ])
                              : _vm._e(),
                          ])
                        : comp.type === "image-ads"
                        ? _c("div", [
                            comp.data.image &&
                            _vm.resolveImg(comp.data.image.url)
                              ? _c("img", {
                                  staticClass: "p-ads-img",
                                  attrs: {
                                    src: _vm.resolveImg(comp.data.image.url),
                                  },
                                })
                              : _c("div", { staticClass: "p-placeholder" }, [
                                  _vm._v("单图广告"),
                                ]),
                          ])
                        : comp.type === "magic-cube"
                        ? _c(
                            "div",
                            {
                              staticClass: "p-cube",
                              class: "cube-" + (comp.data.layout || "1x2"),
                            },
                            _vm._l(comp.data.items || [], function (cell, idx) {
                              return _c(
                                "div",
                                { key: idx, staticClass: "p-cube-cell" },
                                [
                                  _vm.resolveImg(cell.img)
                                    ? _c("img", {
                                        attrs: {
                                          src: _vm.resolveImg(cell.img),
                                        },
                                      })
                                    : _c("span", [
                                        _vm._v("魔方" + _vm._s(idx + 1)),
                                      ]),
                                ]
                              )
                            }),
                            0
                          )
                        : comp.type === "button-group"
                        ? _c(
                            "div",
                            { staticClass: "p-btn-group" },
                            _vm._l(comp.data.items || [], function (btn, idx) {
                              return _c(
                                "div",
                                {
                                  key: idx,
                                  staticClass: "p-btn-item",
                                  style: {
                                    width: 100 / (comp.data.cols || 4) + "%",
                                  },
                                },
                                [
                                  btn.img && _vm.resolveImg(btn.img)
                                    ? _c("img", {
                                        staticClass: "p-btn-img",
                                        class: {
                                          "p-round-img":
                                            comp.data.style === "round",
                                        },
                                        attrs: { src: _vm.resolveImg(btn.img) },
                                      })
                                    : _c(
                                        "div",
                                        {
                                          staticClass: "p-btn-txt",
                                          class: {
                                            "p-round-txt":
                                              comp.data.style === "round",
                                          },
                                        },
                                        [_vm._v(_vm._s(btn.title || "按钮"))]
                                      ),
                                  btn.img && btn.title
                                    ? _c(
                                        "div",
                                        { staticClass: "p-btn-title" },
                                        [_vm._v(_vm._s(btn.title))]
                                      )
                                    : _vm._e(),
                                ]
                              )
                            }),
                            0
                          )
                        : comp.type === "rich-text"
                        ? _c("div", {
                            staticClass: "p-rich",
                            domProps: {
                              innerHTML: _vm._s(comp.data.html || "富文本内容"),
                            },
                          })
                        : comp.type === "goods-group"
                        ? _c(
                            "div",
                            { staticClass: "p-goods" },
                            [
                              _c("div", { staticClass: "p-goods-head" }, [
                                _vm._v(_vm._s(comp.data.title || "商品组")),
                              ]),
                              !comp.data.goods || !comp.data.goods.length
                                ? _c("div", { staticClass: "p-placeholder" }, [
                                    _vm._v("商品组"),
                                  ])
                                : _vm._e(),
                              _vm._l(comp.data.goods, function (gid) {
                                return _c(
                                  "div",
                                  { key: gid, staticClass: "p-goods-card" },
                                  [
                                    _vm.goodsImg(gid)
                                      ? _c("img", {
                                          staticClass: "p-goods-img",
                                          attrs: { src: _vm.goodsImg(gid) },
                                        })
                                      : _c(
                                          "div",
                                          {
                                            staticClass:
                                              "p-goods-img p-goods-img-empty",
                                          },
                                          [_vm._v("图")]
                                        ),
                                    _c("div", { staticClass: "p-goods-info" }, [
                                      _c(
                                        "div",
                                        { staticClass: "p-goods-name" },
                                        [_vm._v(_vm._s(_vm.goodsName(gid)))]
                                      ),
                                      _vm.goodsInfo(gid).minPrice !==
                                        undefined &&
                                      _vm.goodsInfo(gid).minPrice !== null
                                        ? _c(
                                            "div",
                                            { staticClass: "p-goods-price" },
                                            [
                                              _vm._v(
                                                "¥" +
                                                  _vm._s(
                                                    _vm.goodsInfo(gid).minPrice
                                                  )
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]),
                                  ]
                                )
                              }),
                            ],
                            2
                          )
                        : comp.type === "float-btn"
                        ? _c("div", { staticClass: "p-float" }, [
                            _c("div", { staticClass: "p-float-tag" }, [
                              _vm._v("悬浮按钮（顾客端固定右下角）"),
                            ]),
                            _c(
                              "div",
                              { staticClass: "p-float-btns" },
                              _vm._l(comp.data.items || [], function (f, idx) {
                                return _c(
                                  "div",
                                  { key: idx, staticClass: "p-float-btn" },
                                  [
                                    _vm.resolveImg(f.img)
                                      ? _c("img", {
                                          attrs: { src: _vm.resolveImg(f.img) },
                                        })
                                      : _c("span", [_vm._v("+")]),
                                  ]
                                )
                              }),
                              0
                            ),
                          ])
                        : _c("div", { staticClass: "p-placeholder" }, [
                            _vm._v("未知组件 " + _vm._s(comp.type)),
                          ]),
                    ]
                  )
                }),
                0
              ),
            ],
            1
          ),
        ]),
        _c(
          "div",
          { staticClass: "editor-right" },
          [
            _c("div", { staticClass: "panel-title" }, [_vm._v("属性设置")]),
            !_vm.selected
              ? _c("div", { staticClass: "right-empty" }, [
                  _vm._v("请在预览区选择组件"),
                ])
              : _c(
                  "a-form",
                  {
                    attrs: { labelCol: { span: 8 }, wrapperCol: { span: 16 } },
                  },
                  [
                    _c(
                      "a-form-item",
                      { attrs: { label: "组件类型" } },
                      [
                        _c("a-tag", [
                          _vm._v(_vm._s(_vm.typeLabel(_vm.selected.type))),
                        ]),
                      ],
                      1
                    ),
                    _vm.selected.type === "banner"
                      ? [
                          _c(
                            "a-form-item",
                            { attrs: { label: "轮播图片" } },
                            [
                              _vm._l(
                                _vm.selected.data.images || [],
                                function (img, idx) {
                                  return _c(
                                    "div",
                                    { key: idx, staticClass: "prop-img-row" },
                                    [
                                      _c("j-image-upload", {
                                        attrs: {
                                          bizPath: "material",
                                          text: "上传",
                                        },
                                        model: {
                                          value: img.url,
                                          callback: function ($$v) {
                                            _vm.$set(img, "url", $$v)
                                          },
                                          expression: "img.url",
                                        },
                                      }),
                                      _c(
                                        "div",
                                        { staticClass: "prop-img-fields" },
                                        [
                                          _c("a-input", {
                                            attrs: {
                                              placeholder: "跳转链接(可选)",
                                            },
                                            model: {
                                              value: img.link,
                                              callback: function ($$v) {
                                                _vm.$set(img, "link", $$v)
                                              },
                                              expression: "img.link",
                                            },
                                          }),
                                          _c("a-button", {
                                            attrs: {
                                              size: "small",
                                              icon: "minus",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.removeArrayItem(
                                                  _vm.selected.data.images,
                                                  idx
                                                )
                                              },
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                }
                              ),
                              _c(
                                "a-button",
                                {
                                  attrs: {
                                    size: "small",
                                    type: "dashed",
                                    icon: "plus",
                                  },
                                  on: { click: _vm.addBannerImage },
                                },
                                [_vm._v("添加图片")]
                              ),
                              _c("div", { staticClass: "prop-tip" }, [
                                _vm._v("建议尺寸 750×360px"),
                              ]),
                            ],
                            2
                          ),
                          _c(
                            "a-form-item",
                            { attrs: { label: "切换间隔(ms)" } },
                            [
                              _c("a-input-number", {
                                staticStyle: { width: "100%" },
                                attrs: { min: 500, precision: 0 },
                                model: {
                                  value: _vm.selected.data.interval,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.selected.data, "interval", $$v)
                                  },
                                  expression: "selected.data.interval",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      : _vm.selected.type === "search"
                      ? [
                          _c(
                            "a-form-item",
                            { attrs: { label: "占位文案" } },
                            [
                              _c("a-input", {
                                attrs: { placeholder: "如：搜索菜品" },
                                model: {
                                  value: _vm.selected.data.placeholder,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.selected.data,
                                      "placeholder",
                                      $$v
                                    )
                                  },
                                  expression: "selected.data.placeholder",
                                },
                              }),
                            ],
                            1
                          ),
                          _c("div", { staticClass: "prop-tip" }, [
                            _vm._v(
                              "点击行为：已扫桌台进点餐页搜索，未扫码引导扫码点餐"
                            ),
                          ]),
                        ]
                      : _vm.selected.type === "notice"
                      ? [
                          _c(
                            "a-form-item",
                            { attrs: { label: "公告内容" } },
                            [
                              _c("a-textarea", {
                                attrs: { rows: 2 },
                                model: {
                                  value: _vm.selected.data.text,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.selected.data, "text", $$v)
                                  },
                                  expression: "selected.data.text",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "a-form-item",
                            { attrs: { label: "滚动播放" } },
                            [
                              _c("a-switch", {
                                attrs: {
                                  checked: !!_vm.selected.data.scrollable,
                                },
                                on: {
                                  click: () =>
                                    (_vm.selected.data.scrollable =
                                      !_vm.selected.data.scrollable),
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      : _vm.selected.type === "grid-nav"
                      ? [
                          _c(
                            "a-form-item",
                            { attrs: { label: "导航项" } },
                            [
                              _vm._l(
                                _vm.selected.data.items || [],
                                function (item, idx) {
                                  return _c(
                                    "div",
                                    { key: idx, staticClass: "prop-img-row" },
                                    [
                                      _c("j-image-upload", {
                                        attrs: {
                                          bizPath: "material",
                                          text: "上传",
                                        },
                                        model: {
                                          value: item.icon,
                                          callback: function ($$v) {
                                            _vm.$set(item, "icon", $$v)
                                          },
                                          expression: "item.icon",
                                        },
                                      }),
                                      _c(
                                        "div",
                                        { staticClass: "prop-img-fields" },
                                        [
                                          _c("a-input", {
                                            staticStyle: { width: "80px" },
                                            attrs: { placeholder: "标题" },
                                            model: {
                                              value: item.title,
                                              callback: function ($$v) {
                                                _vm.$set(item, "title", $$v)
                                              },
                                              expression: "item.title",
                                            },
                                          }),
                                          _c("a-input", {
                                            attrs: { placeholder: "跳转链接" },
                                            model: {
                                              value: item.link,
                                              callback: function ($$v) {
                                                _vm.$set(item, "link", $$v)
                                              },
                                              expression: "item.link",
                                            },
                                          }),
                                          _c("a-button", {
                                            attrs: {
                                              size: "small",
                                              icon: "minus",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.removeArrayItem(
                                                  _vm.selected.data.items,
                                                  idx
                                                )
                                              },
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                }
                              ),
                              _c(
                                "a-button",
                                {
                                  attrs: {
                                    size: "small",
                                    type: "dashed",
                                    icon: "plus",
                                  },
                                  on: { click: _vm.addGridItem },
                                },
                                [_vm._v("添加导航项")]
                              ),
                              _c("div", { staticClass: "prop-tip" }, [
                                _vm._v(
                                  "建议图标 200×200px；不传图标显示标题首字"
                                ),
                              ]),
                            ],
                            2
                          ),
                        ]
                      : _vm.selected.type === "title-bar"
                      ? [
                          _c(
                            "a-form-item",
                            { attrs: { label: "标题" } },
                            [
                              _c("a-input", {
                                model: {
                                  value: _vm.selected.data.title,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.selected.data, "title", $$v)
                                  },
                                  expression: "selected.data.title",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "a-form-item",
                            { attrs: { label: "更多文字" } },
                            [
                              _c("a-input", {
                                attrs: { placeholder: "留空则不显示" },
                                model: {
                                  value: _vm.selected.data.moreText,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.selected.data, "moreText", $$v)
                                  },
                                  expression: "selected.data.moreText",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "a-form-item",
                            { attrs: { label: "更多链接" } },
                            [
                              _c("a-input", {
                                attrs: {
                                  placeholder: "以/开头的小程序页面路径",
                                },
                                model: {
                                  value: _vm.selected.data.moreLink,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.selected.data, "moreLink", $$v)
                                  },
                                  expression: "selected.data.moreLink",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      : _vm.selected.type === "image-ads"
                      ? [
                          _c(
                            "a-form-item",
                            { attrs: { label: "广告图" } },
                            [
                              _c("j-image-upload", {
                                attrs: { bizPath: "material", text: "上传" },
                                model: {
                                  value: _vm.selected.data.image.url,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.selected.data.image,
                                      "url",
                                      $$v
                                    )
                                  },
                                  expression: "selected.data.image.url",
                                },
                              }),
                              _c("div", { staticClass: "prop-tip" }, [
                                _vm._v("建议尺寸 750×400px"),
                              ]),
                            ],
                            1
                          ),
                          _c(
                            "a-form-item",
                            { attrs: { label: "跳转链接" } },
                            [
                              _c("a-input", {
                                attrs: {
                                  placeholder: "以/开头的小程序页面路径",
                                },
                                model: {
                                  value: _vm.selected.data.image.link,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.selected.data.image,
                                      "link",
                                      $$v
                                    )
                                  },
                                  expression: "selected.data.image.link",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      : _vm.selected.type === "magic-cube"
                      ? [
                          _c(
                            "a-form-item",
                            { attrs: { label: "布局" } },
                            [
                              _c(
                                "a-select",
                                {
                                  on: { change: _vm.onCubeLayoutChange },
                                  model: {
                                    value: _vm.selected.data.layout,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.selected.data, "layout", $$v)
                                    },
                                    expression: "selected.data.layout",
                                  },
                                },
                                [
                                  _c(
                                    "a-select-option",
                                    { attrs: { value: "1x2" } },
                                    [_vm._v("一行两个")]
                                  ),
                                  _c(
                                    "a-select-option",
                                    { attrs: { value: "1x3" } },
                                    [_vm._v("一行三个")]
                                  ),
                                  _c(
                                    "a-select-option",
                                    { attrs: { value: "2x2" } },
                                    [_vm._v("两行四个")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "a-form-item",
                            { attrs: { label: "魔方图片" } },
                            _vm._l(
                              _vm.selected.data.items || [],
                              function (cell, idx) {
                                return _c(
                                  "div",
                                  { key: idx, staticClass: "prop-img-row" },
                                  [
                                    _c("j-image-upload", {
                                      attrs: {
                                        bizPath: "material",
                                        text: "上传",
                                      },
                                      model: {
                                        value: cell.img,
                                        callback: function ($$v) {
                                          _vm.$set(cell, "img", $$v)
                                        },
                                        expression: "cell.img",
                                      },
                                    }),
                                    _c(
                                      "div",
                                      { staticClass: "prop-img-fields" },
                                      [
                                        _c("a-input", {
                                          attrs: {
                                            placeholder: "跳转链接(可选)",
                                          },
                                          model: {
                                            value: cell.link,
                                            callback: function ($$v) {
                                              _vm.$set(cell, "link", $$v)
                                            },
                                            expression: "cell.link",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              }
                            ),
                            0
                          ),
                        ]
                      : _vm.selected.type === "button-group"
                      ? [
                          _c(
                            "a-form-item",
                            { attrs: { label: "按钮形式" } },
                            [
                              _c(
                                "a-radio-group",
                                {
                                  model: {
                                    value: _vm.selected.data.style,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.selected.data, "style", $$v)
                                    },
                                    expression: "selected.data.style",
                                  },
                                },
                                [
                                  _c(
                                    "a-radio",
                                    { attrs: { value: "square" } },
                                    [_vm._v("方角")]
                                  ),
                                  _c("a-radio", { attrs: { value: "round" } }, [
                                    _vm._v("圆角"),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "a-form-item",
                            { attrs: { label: "每行数量" } },
                            [
                              _c("a-input-number", {
                                staticStyle: { width: "100%" },
                                attrs: { min: 2, max: 5, precision: 0 },
                                model: {
                                  value: _vm.selected.data.cols,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.selected.data, "cols", $$v)
                                  },
                                  expression: "selected.data.cols",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "a-form-item",
                            { attrs: { label: "按钮项" } },
                            [
                              _vm._l(
                                _vm.selected.data.items || [],
                                function (item, idx) {
                                  return _c(
                                    "div",
                                    { key: idx, staticClass: "prop-img-row" },
                                    [
                                      _c("j-image-upload", {
                                        attrs: {
                                          bizPath: "material",
                                          text: "上传",
                                        },
                                        model: {
                                          value: item.img,
                                          callback: function ($$v) {
                                            _vm.$set(item, "img", $$v)
                                          },
                                          expression: "item.img",
                                        },
                                      }),
                                      _c(
                                        "div",
                                        { staticClass: "prop-img-fields" },
                                        [
                                          _c("a-input", {
                                            staticStyle: { width: "70px" },
                                            attrs: { placeholder: "文字" },
                                            model: {
                                              value: item.title,
                                              callback: function ($$v) {
                                                _vm.$set(item, "title", $$v)
                                              },
                                              expression: "item.title",
                                            },
                                          }),
                                          _c("a-input", {
                                            attrs: { placeholder: "跳转链接" },
                                            model: {
                                              value: item.link,
                                              callback: function ($$v) {
                                                _vm.$set(item, "link", $$v)
                                              },
                                              expression: "item.link",
                                            },
                                          }),
                                          _c("a-button", {
                                            attrs: {
                                              size: "small",
                                              icon: "minus",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.removeArrayItem(
                                                  _vm.selected.data.items,
                                                  idx
                                                )
                                              },
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                }
                              ),
                              _c(
                                "a-button",
                                {
                                  attrs: {
                                    size: "small",
                                    type: "dashed",
                                    icon: "plus",
                                  },
                                  on: { click: _vm.addButtonItem },
                                },
                                [_vm._v("添加按钮")]
                              ),
                              _c("div", { staticClass: "prop-tip" }, [
                                _vm._v(
                                  "不传图片渲染为文字按钮；建议图标 200×200px"
                                ),
                              ]),
                            ],
                            2
                          ),
                        ]
                      : _vm.selected.type === "rich-text"
                      ? [
                          _c(
                            "a-form-item",
                            { attrs: { label: "内容" } },
                            [
                              _c("a-textarea", {
                                attrs: {
                                  rows: 8,
                                  placeholder:
                                    "支持 HTML 标签，如 <p>活动规则</p><img src='图片地址'>",
                                },
                                model: {
                                  value: _vm.selected.data.html,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.selected.data, "html", $$v)
                                  },
                                  expression: "selected.data.html",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      : _vm.selected.type === "goods-group"
                      ? [
                          _c(
                            "a-form-item",
                            { attrs: { label: "组标题" } },
                            [
                              _c("a-input", {
                                model: {
                                  value: _vm.selected.data.title,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.selected.data, "title", $$v)
                                  },
                                  expression: "selected.data.title",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "a-form-item",
                            { attrs: { label: "已选商品" } },
                            [
                              _vm._l(
                                _vm.selected.data.goods || [],
                                function (gid) {
                                  return _c(
                                    "div",
                                    { key: gid, staticClass: "prop-goods" },
                                    [
                                      _c("span", [
                                        _vm._v(_vm._s(_vm.goodsName(gid))),
                                      ]),
                                      _c("a-button", {
                                        attrs: { size: "small", icon: "close" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.removeGoods(gid)
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                }
                              ),
                              _c(
                                "a-button",
                                {
                                  attrs: {
                                    size: "small",
                                    type: "dashed",
                                    icon: "plus",
                                  },
                                  on: { click: _vm.openGoodsPicker },
                                },
                                [_vm._v("选择商品")]
                              ),
                            ],
                            2
                          ),
                        ]
                      : _vm.selected.type === "float-btn"
                      ? [
                          _c(
                            "a-form-item",
                            { attrs: { label: "悬浮按钮" } },
                            [
                              _vm._l(
                                _vm.selected.data.items || [],
                                function (f, idx) {
                                  return _c(
                                    "div",
                                    { key: idx, staticClass: "prop-img-row" },
                                    [
                                      _c("j-image-upload", {
                                        attrs: {
                                          bizPath: "material",
                                          text: "上传",
                                        },
                                        model: {
                                          value: f.img,
                                          callback: function ($$v) {
                                            _vm.$set(f, "img", $$v)
                                          },
                                          expression: "f.img",
                                        },
                                      }),
                                      _c(
                                        "div",
                                        { staticClass: "prop-img-fields" },
                                        [
                                          _c("a-input", {
                                            attrs: {
                                              placeholder: "跳转链接(可选)",
                                            },
                                            model: {
                                              value: f.link,
                                              callback: function ($$v) {
                                                _vm.$set(f, "link", $$v)
                                              },
                                              expression: "f.link",
                                            },
                                          }),
                                          _c("a-button", {
                                            attrs: {
                                              size: "small",
                                              icon: "minus",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.removeArrayItem(
                                                  _vm.selected.data.items,
                                                  idx
                                                )
                                              },
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                }
                              ),
                              _c(
                                "a-button",
                                {
                                  attrs: {
                                    size: "small",
                                    type: "dashed",
                                    icon: "plus",
                                    disabled:
                                      _vm.selected.data.items.length >= 4,
                                  },
                                  on: { click: _vm.addFloatItem },
                                },
                                [_vm._v("添加按钮")]
                              ),
                              _c("div", { staticClass: "prop-tip" }, [
                                _vm._v(
                                  "最多 4 个，顾客端固定悬浮于页面右下角；建议 160×160px"
                                ),
                              ]),
                            ],
                            2
                          ),
                        ]
                      : _vm._e(),
                  ],
                  2
                ),
          ],
          1
        ),
      ]),
      _c(
        "a-modal",
        {
          staticStyle: { top: "80px" },
          attrs: {
            title: "选择商品",
            visible: _vm.pickerVisible,
            width: 760,
            footer: null,
            maskClosable: false,
          },
          on: {
            cancel: function ($event) {
              _vm.pickerVisible = false
            },
          },
        },
        [
          _c(
            "a-spin",
            { attrs: { spinning: _vm.pickerLoading } },
            [
              _c(
                "div",
                { staticStyle: { "margin-bottom": "12px" } },
                [
                  _c("a-input-search", {
                    staticStyle: { width: "300px" },
                    attrs: {
                      placeholder: "请输入商品名搜索",
                      "allow-clear": "",
                    },
                    on: { search: () => _vm.loadGoods(1) },
                    model: {
                      value: _vm.pickerSearch,
                      callback: function ($$v) {
                        _vm.pickerSearch = $$v
                      },
                      expression: "pickerSearch",
                    },
                  }),
                ],
                1
              ),
              _c("a-table", {
                attrs: {
                  size: "small",
                  bordered: "",
                  rowKey: "materialId",
                  columns: _vm.pickerColumns,
                  dataSource: _vm.pickerRows,
                  pagination: _vm.pickerPager,
                },
                on: { change: _vm.onPickerChange },
                scopedSlots: _vm._u([
                  {
                    key: "checkSlot",
                    fn: function (text, record) {
                      return [
                        _c("a-checkbox", {
                          attrs: {
                            checked:
                              _vm.pickerTarget &&
                              _vm.pickerTarget.data.goods.indexOf(
                                record.materialId
                              ) > -1,
                          },
                          on: { click: () => _vm.togglePickGoods(record) },
                        }),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }